import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { CustomTitleWithRadio } from 'components/earning/CustomBaseComponments';

const ReactHookFormTitleWithRadio = ({
  title,
  valueFieldName,
  defaultValue,
  customTitleClass,
  optionsClassName,
  popoverTips,
  disabled,
  options,
  tips,
  bottomDescription,
  focusKey = '',
  extraActionOnChange = () => {},
  focusChange = () => {},
}) => {
  const { watch, setValue } = useFormContext();
  const watchValue = watch(valueFieldName);
  const setValueAction = (value) => {
    console.log('@@34-1: ', valueFieldName, value);
    setValue(valueFieldName, value, { shouldDirty: true });
    extraActionOnChange && extraActionOnChange(value);
  };
  useEffect(() => {
    if (!watchValue && defaultValue) {
      setValue(valueFieldName, defaultValue, { shouldDirty: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchValue]);
  console.log('@@34: ', valueFieldName, watchValue);
  return (
    <CustomTitleWithRadio
      title={title}
      customTitleClass={customTitleClass}
      popoverTips={popoverTips}
      disabled={disabled}
      options={options}
      optionsClassName={optionsClassName}
      tips={tips}
      bottomDescription={bottomDescription}
      defaultValue={watchValue}
      setValue={setValueAction}
      onFocus={() => {
        focusKey && focusChange(focusKey);
      }}
    />
  );
};

export default ReactHookFormTitleWithRadio;